import {
  Component, Input, OnInit, OnDestroy, Type, Injector,
  OnChanges, SimpleChanges
} from '@angular/core';
import { VitalComponent } from '../check-sheet/vital/vital.component';
import { animate, style, transition, trigger } from '@angular/animations';
import { ShowcaseSyncService } from '@core/services/common/showcase-timer.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'caremoni-showcase',
  templateUrl: './showcase.component.html',
  styleUrls: ['./showcase.component.scss'],
  animations: [
    trigger('fadeSwitch', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms ease-in-out', style({ opacity: 1 }))
      ]),
      transition(':increment, :decrement', [
        style({ opacity: 0 }),
        animate('300ms ease-in-out', style({ opacity: 1 }))
      ])
    ])
  ]
})
export class ShowcaseComponent implements OnInit, OnDestroy, OnChanges {
  @Input() data: any[] = [];
  @Input() itemComponent: Type<any> = VitalComponent;
  @Input() interval: number = 5000;

  currentIndex: number = 0;
  injectors: Injector[] = [];
  private sub?: Subscription;
  recordTime: string = '';

  constructor(
    private injector: Injector,
    private syncService: ShowcaseSyncService
  ) {}

  ngOnInit(): void {
    this.sub = this.syncService.switch$.subscribe(() => {
      this.movePrev();
    });
    this.syncService.start(this.interval, true);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && (changes['data']?.currentValue?.length ?? 0) > 0) {
      
      this.data = [...this.data].reverse();
      this.currentIndex = this.data.length - 1;  
    //   this.currentIndex = 0;
      this.createInjectors();
      this.setRecordTime();
    }
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  private movePrev() {
    if (!this.data?.length) return;
    this.currentIndex = (this.currentIndex - 1 + this.data.length) % this.data.length;
    this.setRecordTime();
  }

  private moveNext() {
    if (!this.data?.length) return;
    this.currentIndex = (this.currentIndex + 1) % this.data.length;
    this.setRecordTime();
  }

  setRecordTime() {
    const rawDate = this.data?.[this.currentIndex]?.date;

    if (typeof rawDate === 'string' && rawDate.includes(' ')) {
        const [, timePart] = rawDate.split(' ');
        const timeValid = /^(\d{1,2}):(\d{2})$/.test(timePart);
        this.recordTime = timeValid ? timePart : '';
    } else {
        this.recordTime = '';
    }
  }


  private createInjectors() {
    this.injectors = this.data.map(item =>
      Injector.create({
        providers: [{ provide: 'showcaseData', useValue: item }],
        parent: this.injector
      })
    );
  }

  isDotVisible(index: number): boolean {
    return index < 3;
  }
}
